import vue from 'vue'
import to from 'await-to-js'
import buildClient from '@/api/client'
import getTerritoryStatesByCountryIsoQuery from '@/api/territory-states-by-country-iso.gql'

let isFetchingStates = false

export default {
  namespaced: true,
  state: {
    countries: [],
    statesByCountryIso: {},
  },

  getters: {
    shippingCountries: state => state.countries.filter(obj => obj.isShippingCountry),
    billingCountries: state => state.countries,
    getCountryById: state => countryId =>
      state.countries.find(({ id }) => id === countryId) || null,
    getCountryByIso: state => countryIso => state.countries.find(({ iso }) => iso === countryIso),
    getStatesByCountryIso: state => countryIso => state.statesByCountryIso[countryIso] || [],
  },

  mutations: {
    setCountries(state, countries) {
      state.countries = countries
    },
    addStatesByCountryIso(state, statesByCountryIso) {
      Object.keys(statesByCountryIso).forEach(iso => {
        vue.set(state.statesByCountryIso, iso, statesByCountryIso[iso])
      })
    },
  },

  actions: {
    async fetchStates({ dispatch, getters }, countryIso) {
      if (isFetchingStates) return
      const billingAddressCountryStates = getters.getStatesByCountryIso(countryIso)
      if (billingAddressCountryStates.length > 0) return // don't refetch if arleady present
      isFetchingStates = true
      const [error, result] = await to(
        buildClient().query(getTerritoryStatesByCountryIsoQuery, { countryIso })
      )
      isFetchingStates = false
      if (error) throw error
      if (!result) throw new Error(`Fetching states for country "${countryIso}" failed`)
      const { territories } = result
      dispatch('handleFetchData', { territories, statesCountryIso: countryIso })
    },
    handleFetchData({ commit }, { territories, statesCountryIso }) {
      if (territories.countries) {
        commit('setCountries', territories.countries)
      }
      if (territories.states && statesCountryIso) {
        const statesByCountryIso = {
          [statesCountryIso]: territories.states,
        }
        commit('addStatesByCountryIso', statesByCountryIso)
      }
    },
  },
}
